module.exports = __webpack_public_path__ + "img/Mb_pressrelease.9d2b4f56.jpg";